import { CostoPago } from '../../objetos/objeto_costos';
import { costosApi } from '../../services/api';
import React, { useState, useMemo } from 'react';
import { useLoading } from '../../utils/LoadingProvider';
import { toast } from 'react-toastify';
import { getSocket } from '../../services/socket';

export const useCostosModel = () =>{
    const [costos, setCostos] = useState([]);
    const [loadingCostos, setLoading] = useState(true);
    const [errorCostos, setError] = useState(null);

    //lista de conceptos
    const [listaConceptos, setListaConceptos] = useState([]);
    const [loadingConceptos, setLoadingConceptos] = useState(true);

    //lista de provedores
    const [listaProveedores, setListaProveedores] = useState([]);
    const [loadingListaProveedores, setLoadingListaProveedores] = useState(true);

    const { withLoading } = useLoading();


    //add costo
    const addNewCosto = async(nombreEmpresa, costoData) =>{
        return await withLoading(async () =>{
            try{
                console.log("añadiendo nuevo costo");

                const costoInstance = new CostoPago(costoData);
                const costoMap = costoInstance.toMap();

                const respuesta = await costosApi.addCosto(nombreEmpresa, costoMap,costoData);

                toast.success(respuesta.message);
            }
            catch(error){
                console.error('Error interno:', error);
                throw error;
            }
        }, 'Añadiendo nuevo costo...')
    }
    //cargar costos
    const cargarCostos = async (nombreEmpresa) =>{
        try{
            setLoading(true);
            setError(null);

            const response = await costosApi.getCostos(nombreEmpresa);
            const data = response.data;
            const dataConvertida = Object.values(data);
            const costos_obj = dataConvertida.map(costoData => CostoPago.fromJson(costoData));
            setCostos(costos_obj);

        }
        catch(error){
            setError('Error al cargar los costos: ' + error.message);
        }
        finally{
            setLoading(false);
        }
    }

    //actualizar cosot
    const updateCosto = async(documentoId,nombreEmpresa,field,valor,type = 'field') =>{
        return withLoading(async () =>{
            let finalUpdateData = {};

            if(!field ){
                toast.error("Este error no deberia salir");
                return;
            }

            if(type == "field" ){
                const datosParaValidar = { [field]: valor };
                const costoTemporal = new CostoPago({});
                costoTemporal.updateFromJson(datosParaValidar);

                const valorConvertido = costoTemporal.getFieldValue(field);

                finalUpdateData = {
                    [field]: valorConvertido
                    };
            }
            else if(type == "array"){
               
            }

            try{

                console.log("update costo",documentoId,nombreEmpresa,field,valor,type);

                const respuesta = await costosApi.updateCosto(documentoId,nombreEmpresa,finalUpdateData,type);

                console.log("tenemos respuesta",respuesta);

                if (respuesta.success) {
                    toast.success(`Exito: ${respuesta.message}`);
                } else {
                    toast.error(`Error: ${respuesta.message}`);
                }

            }
            catch(error){
                console.error('Error al actualizar costo', error);
                toast.error("Ocurrió un error a actualizar el costo: " + (error.message || "Error desconocido"));
                return { success: false, error: error };
            }

        },'Actualizando costo')
    }

    const cargarListaConceptos = async(nombreEmpresa) =>{
        try{
            setLoadingConceptos(true);

            const response = await costosApi.getListaConceptos(nombreEmpresa);
            const data = response.data;

            setListaConceptos(data || []);
        }
        catch(error){
            
        }
        finally{
            setLoadingConceptos(false);
        }
    }
    const listaConceptosOptions = useMemo(() => {
    if (!listaConceptos || listaConceptos.length === 0) {
        return [];
    }

    return listaConceptos.map(concepto => ({
        value: concepto,
        label: concepto, 
    }));

    }, [listaConceptos]); 

    const cargarListaProveedores = async(nombreEmpresa) =>{
        try{
            setLoadingListaProveedores(true);

            const response = await costosApi.getListaProveedores(nombreEmpresa);
            const data = response.data;
            setListaProveedores(data || []);
        }
        catch(error){
            
        }
        finally{
            setLoadingListaProveedores(false);
        }
    }
    const listaProveedoresOptions = useMemo(() => {
    if (!listaProveedores || listaProveedores.length === 0) {
        return [];
    }

    return listaProveedores.map(proveedor => ({
        value: proveedor,
        label: proveedor, 
    }));

    }, [listaProveedores]);

    //webhook
    const setupWebSocketsCostos = (nombreEmpresaActual) =>{
        const socket = getSocket();

        const handleCostosUpdate = ({ data, type, nombreEmpresa }) => {
            console.log(`Evento WebSocket 'modified' recibido. ${type} ${nombreEmpresa}`);
            console.log("probando",nombreEmpresa,nombreEmpresaActual);
            console.log(nombreEmpresa !== nombreEmpresaActual);
            console.log(type !== 'modified');
            // 1. Filtrar eventos por empresa
            if (nombreEmpresa !== nombreEmpresaActual) {
                return;
            }

            // 2. Lógica de "Upsert" usando 'documentoId'
            setCostos(prevCostos => {
                const costoRecibido = CostoPago.fromJson(data);
                
                // CORRECCIÓN: Usar 'documentoId' como identificador único.
                const docIdRecibido = costoRecibido.documentoId;

                // Buscamos el índice del costo usando 'documentoId'
                const indiceExistente = prevCostos.findIndex(c => c.documentoId === docIdRecibido);

                // Si no se encuentra (índice es -1), lo creamos.
                if (indiceExistente === -1) {
                    console.log(`Costo nuevo (documentoId: ${docIdRecibido}). Añadiendo.`);
                    return [costoRecibido, ...prevCostos];
                }

                // Si se encuentra, lo actualizamos.
                console.log(`Costo existente (documentoId: ${docIdRecibido}). Actualizando.`);
                const costosActualizados = [...prevCostos];
                costosActualizados[indiceExistente] = costoRecibido;
                
                return costosActualizados;
            });
            
        };

        socket.on('costos:update', handleCostosUpdate);

        // 3. Devolver una función de limpieza para desuscribirse del evento
        return () => {
            console.log("Desuscribiendo del evento costos:update");
            socket.off('costos:update', handleCostosUpdate);
        };

    }

    return{
        costos,
        loadingCostos,
        errorCostos,
        cargarCostos,
        setupWebSocketsCostos,

        cargarListaConceptos,
        listaConceptosOptions,

        cargarListaProveedores,
        listaProveedoresOptions,

        //add
        addNewCosto,
        updateCosto,
    };

}